import { Fill, Stroke, Style } from 'ol/style';
import * as Color from 'color';
import { baseStyle } from '@vendor/libs/maps/styles/base';
export const unaffiliatedApiaryBufferStyle = (muted = false) => {
    let colors = { stroke: '#171717', fill: 'rgba(150,150,150,0.2)' };
    if (muted) {
        colors.fill = Color(colors.fill)
            .alpha(Color(colors.fill).alpha() * 0.4)
            .hexa();
        colors.stroke = Color(colors.stroke)
            .alpha(Color(colors.stroke).alpha() * 0.3)
            .hexa();
    }
    return [
        new Style({
            stroke: new Stroke({
                color: colors.stroke,
                width: 2.5,
            }),
            fill: new Fill({
                color: colors.fill,
            }),
        }),
        new Style({
            stroke: new Stroke({
                color: 'white',
                width: 0.3,
            }),
        }),
    ];
};
export default (feature, resolution) => {
    return baseStyle(feature, resolution, () => {
        if (resolution > 250) {
            return new Style({});
        }
        return unaffiliatedApiaryBufferStyle(feature.get('muted'));
    });
};
